// src/components/dialog/DlgRegistrationConfirmation.tsx

import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

type Props = {
  open: boolean
  title?: string
}

export const DlgRegistrationConfirmation = ({
  open,
  title = 'Registrierung erfolgreich abgeschlossen!',
}: Props) => {
  const navigate = useNavigate()
  const gotoLogin = () => navigate('/pages/login-page')

  return (
    <Dialog open={open}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Alert severity={'info'}>
          <Typography sx={{ mb: 2 }}>
            Wir haben Ihnen eine E-Mail mit einem Bestätigungslink geschickt.
          </Typography>

          <Typography sx={{ mb: 2 }}>
            Bitte beachten Sie, dass Sie Ihren KARMA Account erst nach der
            Bestätigung Ihrer E-Mail Adresse nutzen können.
          </Typography>
        </Alert>

        <Box sx={{ textAlign: 'center' }}>
          <Button onClick={gotoLogin} sx={{ my: 1 }}>
            Zum Login
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
